<template>
  <div>
    <b-card>
      <TitleTable titleTable="Agent Members" iconTable="fas fa-users" />
      <div class="m-1 d-flex align-items-center justify-content-end">
        <GoBack class="mr-2" />
        <b-button variant="primary" @click="goToAddMember">
          <i class="fas fa-plus mr-1"></i>
          Add Member
        </b-button>
      </div>
      <agent-affiliates-table />
    </b-card>
  </div>
</template>

<script>
import { BButton, BCard } from 'bootstrap-vue'
import TitleTable from '@/components/TitleTable.vue'
import GoBack from '@/components/ButtonBack.vue'
import AgentAffiliatesTable from './dashboard/AgentAffiliatesTable.vue'

/**
 * Afiliados del agente desde agent-plan/dashboard/affiliates.
 * El agente solo recibe nombre e inicial del apellido: sin teléfono, correo ni fecha de nacimiento.
 */
export default {
  name: 'MembersList',
  components: {
    BButton,
    BCard,
    TitleTable,
    GoBack,
    AgentAffiliatesTable,
  },
  methods: {
    goToAddMember() {
      this.$router.push({ name: 'agent-plan-add-member' })
    },
  },
}
</script>
